(() => {
    const body = document.querySelector('body.unlazyload');

    if (body === null) {
        return null;
    }

    const delay = 1000;
    const intervalDelay = 100;
    const lazyImages = document.querySelectorAll('[loading="lazy"]');

    window.addEventListener('load', (event) => {
        setTimeout(init, delay);
    });

    function init() {
        if (lazyImages.length === 0) {
            return null;
        }
        
        lazyImages.forEach((img, i) => {
            loadImage(i);
        });
    }

    function loadImage(i) {
        if (typeof lazyImages[i] == 'undefined') {
            return null;
        }

        const img = lazyImages[i];

        img.addEventListener('load', () => {
            setTimeout(() => {
                loadImage(i + 1);
            }, intervalDelay);
        });

        img.removeAttribute('loading');
    }

})();